import { NgDocCategory } from '@ng-doc/core';

const MServiceCategory: NgDocCategory = {
  title: 'M-Tools',
  order: 4,
};

export default MServiceCategory;
